/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Button, VStack } from '@chakra-ui/react';
import { UserBooleanComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';
import { ButtonVariant } from '@/themes/ButtonVariants';
import { ComponentRendererProps } from '../ComponentRenderer';

export function UserBooleanRenderer(props: ComponentRendererProps) {
  const typedParams = props.node.params as ParsedParams<UserBooleanComponent>;
  const component = props.node.component as UserBooleanComponent;

  const setSelected = (value: boolean) => {
    if (props.isCurrent) {
      props.writeOutput(component.selected, value);
    }
  };

  return (
    <VStack spacing="3px" width="150px" alignItems="stretch">
      <Button
        variant={typedParams.selected === true ? ButtonVariant.secondary : ButtonVariant.secondary_outlined}
        onClick={() => setSelected(true)}
      >
        {typedParams.true_label}
      </Button>
      <Button
        variant={typedParams.selected === false ? ButtonVariant.secondary : ButtonVariant.secondary_outlined}
        onClick={() => setSelected(false)}
      >
        {typedParams.false_label}
      </Button>
    </VStack>
  );
}
